<template>

    <div class="form-group">
        <label v-if="hideLabel === false">{{ element.display_name }}</label>
        <file-manager-audio-select
            v-model="element.value"
            :mime-types="element.mime_types"
            :hide-hints="hideLabel"
            @change="handleInput"
        ></file-manager-audio-select>
        <div class="d-block invalid-feedback" v-if="error">{{ error }}</div>
    </div>

</template>

<script>

import File from '../file-manager/classes/File';

export default {

    name: 'PersonalizedGameEditorAudio',

    props: {
        value: Object,
        location: String,
        hideLabel: Boolean
    },

    data() {
        return {
            eventHub: window.eventHub,
            element: this.value,
            error: null
        }
    },

    computed: {
        elementLocation() {
            if (this.location) {
                return this.location + '.' + this.element.name;
            }
            return this.element.name
        }
    },

    beforeMount() {
        this.element.value = new File(this.element.value);
    },

    mounted() {
        this.eventHub.$on('personalized-games-update-errors', errors => {
            if (errors[this.elementLocation] !== undefined) {
                this.error = errors[this.elementLocation];
            } else {
                this.error = null;
            }
        });
    },

    methods: {
        handleInput (e) {
            this.$emit('input', this.element)
        }
    }

}
</script>

<style scoped>

</style>
